import { createAsyncThunk } from '@reduxjs/toolkit';
import { PlaidApi, ExchangePublicTokenResponse } from 'api/PlaidApi';

export interface ExchangePublicTokenParams {
  applicationId: string;
  plaidPublicToken: string;
}

export const createExchangePublicTokenThunk = (api: PlaidApi) =>
  createAsyncThunk<ExchangePublicTokenResponse, ExchangePublicTokenParams>(
    'plaid/exchangePublicToken',
    async (payload: ExchangePublicTokenParams) => {
      const { applicationId, plaidPublicToken } = payload;
      return api.exchangePublicToken(applicationId, plaidPublicToken);
    },
  );

export default createExchangePublicTokenThunk;
